var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMentalHealthGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "community",
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276732",
    "data-name": "Path 276732",
    d: "M58.5,18a4.983,4.983,0,0,0-1.061.119A29.18,29.18,0,0,0,45.881,6.561,4.978,4.978,0,0,0,41,.5H23a4.981,4.981,0,0,0-4.882,6.058A29.3,29.3,0,0,0,6.544,18.114,4.985,4.985,0,0,0,.5,23V41a4.987,4.987,0,0,0,6.044,4.887A29.311,29.311,0,0,0,18.118,57.443,4.979,4.979,0,0,0,23,63.5H41a4.987,4.987,0,0,0,4.887-6.044A29.3,29.3,0,0,0,57.442,45.882,4.979,4.979,0,0,0,63.5,41V23a5,5,0,0,0-5-5ZM55.77,32a2.975,2.975,0,1,1-2.97-2.98A2.975,2.975,0,0,1,55.77,32ZM23,3.5H41a2,2,0,0,1,0,4H36.681a5.962,5.962,0,0,0-9.362,0H23a2,2,0,0,1,0-4Zm11.98,7.7A2.98,2.98,0,1,1,32,8.23a2.98,2.98,0,0,1,2.98,2.97ZM8.23,32a2.975,2.975,0,1,1,2.97,2.98A2.975,2.975,0,0,1,8.23,32ZM3.5,41V23a2,2,0,0,1,4,0v4.319a5.962,5.962,0,0,0,0,9.363V41a2,2,0,0,1-4,0ZM41,60.5H23a2,2,0,0,1,0-4h4.319a5.962,5.962,0,0,0,9.362,0H41a2,2,0,0,1,0,4ZM29.02,52.8A2.98,2.98,0,1,1,32,55.769a2.98,2.98,0,0,1-2.98-2.97ZM44.4,54.854A4.968,4.968,0,0,0,41,53.5H37.938a6.077,6.077,0,0,0,.042-.7,5.98,5.98,0,0,0-11.96,0,6.157,6.157,0,0,0,.042.7H23a4.906,4.906,0,0,0-3.382,1.345A26.282,26.282,0,0,1,9.146,44.4,4.968,4.968,0,0,0,10.5,41V37.938a6.067,6.067,0,0,0,.7.043,5.98,5.98,0,0,0,0-11.961,6.157,6.157,0,0,0-.7.042V23a4.908,4.908,0,0,0-1.356-3.4A26.279,26.279,0,0,1,19.615,9.156,4.967,4.967,0,0,0,23,10.5h3.062a6.077,6.077,0,0,0-.042.7,5.98,5.98,0,0,0,11.96,0,6.157,6.157,0,0,0-.042-.7H41a4.908,4.908,0,0,0,3.38-1.343,26.169,26.169,0,0,1,10.461,10.46A4.966,4.966,0,0,0,53.5,23v3.062a6.077,6.077,0,0,0-.7-.042,5.98,5.98,0,1,0,0,11.961,6.133,6.133,0,0,0,.7-.042V41a4.907,4.907,0,0,0,1.345,3.383A26.279,26.279,0,0,1,44.4,54.854ZM60.5,41a2,2,0,0,1-4,0V36.682a5.962,5.962,0,0,0,0-9.363V23a2,2,0,0,1,4,0Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276733",
    "data-name": "Path 276733",
    d: "M32,24.674c-.058,0-.115.007-.172.009a12.777,12.777,0,0,0-1.989,6.067h4.318a12.777,12.777,0,0,0-1.992-6.068C32.109,24.681,32.055,24.674,32,24.674Z",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276734",
    "data-name": "Path 276734",
    d: "M32,39.238a18.187,18.187,0,0,0,2.052-5.988h-4.1A18.187,18.187,0,0,0,32,39.238Z",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276735",
    "data-name": "Path 276735",
    d: "M27.348,30.75a14.731,14.731,0,0,1,1.224-5.22,7.34,7.34,0,0,0-3.785,5.233c.023,0,.043-.013.067-.013Z",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276736",
    "data-name": "Path 276736",
    d: "M24.853,33.25c-.024,0-.043-.012-.067-.013a7.338,7.338,0,0,0,4.16,5.414,19.134,19.134,0,0,1-1.505-5.4Z",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276737",
    "data-name": "Path 276737",
    d: "M36.56,33.25a19.14,19.14,0,0,1-1.508,5.4,7.338,7.338,0,0,0,4.161-5.415c-.023,0-.043.013-.067.013Z",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276738",
    "data-name": "Path 276738",
    d: "M42.375,19.625H21.625a2,2,0,0,0-2,2v20.75a2,2,0,0,0,2,2h20.75a2,2,0,0,0,2-2V21.625A2,2,0,0,0,42.375,19.625ZM32,41.826A9.826,9.826,0,1,1,41.826,32,9.826,9.826,0,0,1,32,41.826Z",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276739",
    "data-name": "Path 276739",
    d: "M35.423,25.528a14.731,14.731,0,0,1,1.226,5.222h2.5c.024,0,.043.012.067.013a7.34,7.34,0,0,0-3.79-5.236Z",
    fill: "#fd930d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentalHealthGlobe);
export default __webpack_public_path__ + "static/media/Mental_Health_Globe.0d4b1916b5b862d475ae1e03ef345229.svg";
export { ForwardRef as ReactComponent };